import axios from 'axios'
axios.defaults.headers.common['Cache-Control'] ='no-cache';

const API_PREFIX = "/api/onboarding"

export const apiFetchConfiguration = lineid => {
    return axios.get(`${API_PREFIX}/public/configuration/${lineid}`)
}

export const apiUpdateConfiguration = payload => {
    return axios.put(`${API_PREFIX}/public/configuration`, payload)
}